<template>
  <div :class="title?'inputBlock':'inputBlock outerDiv'" :id="'a_'+name">
    <label v-if="title" for="" :class="isfloat?'floatLeft':''" v-html="title"></label>
    <div v-if="error" v-on:click="removeErr($event,name)" class="erorContent">
      <p><i class="fa fa-exclamation-circle"></i> {{error}}</p>
    </div>
    <div v-if="custom" class="customBlk">
      <div class="left" v-html="custom"></div>
      <input v-on:focus="removeErr($event,name)" :readonly="readOnly" :autocomplete="boxtype=='password'?'new-password':''" :name="name" :type="boxtype?boxtype:'text'" :class="(error?'form-control errorMessage inputText':'form-control inputText')+(isfloat?' floatRight inputRightAligned':'')" :placeholder="res.hints[name]" v-bind:value="value" v-on:input="changed($event)">
    </div>
    <input v-else :readonly="readOnly" v-on:focus="removeErr($event,name)" :autocomplete="boxtype=='password'?'new-password':''" :name="name" :type="boxtype?boxtype:'text'" :class="(error?'form-control errorMessage inputText':'form-control inputText')+(isfloat?' floatRight inputRightAligned':'')" :placeholder="res.hints[name]" v-bind:value="value" v-on:input="changed($event)">
    <div class="clearFix" v-if="isfloat"></div>
  </div>
</template>

<script>

import utils from './Utils.vue'

export default {
  name: 'inputbox',
  props:['title', 'name', 'value', 'res', 'isfloat', 'boxtype', 'custom', 'readOnly'],
  data () {
    return {
      "error":null
    }
  },
  components: {
  },
  created: function() {
  },
  methods: {
    changed: function(evt) {
      this.$emit('input', evt.target.value);
    },
    removeErr: function(evt, name) {
      this.error = null;
    }
  },
  mounted: function() {
    this.$root.$on(this.name, data => {
      this.error = null;
      if (data != null) {
        if (data.error != null) {
          this.error = data.error;
        }
      } else {
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InputBox.vue